<template>
    <div class="l-edit-dialog-box">
        <el-form :model="form_data" label-width="120px" ref="form" :rules="rules" label-position="left" v-loading="loading">
            <el-row :gutter="50" style="margin-left:0;margin-right:0">

                <el-col :span="24">
                    <el-form-item label="员工ID" prop="admin_id">
                        <el-input v-model="form_data.admin_id" autocomplete="off" placeholder="请输入员工ID"></el-input>
                    </el-form-item>
                </el-col>

                <el-col :span="24">
                    <el-form-item label="备注" prop="remark">
                        <el-input type="textarea" v-model="form_data.remark" autocomplete="off" :rows="4" maxlength="250"
                            placeholder="请输入备注" show-word-limit></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
        <div class="l-dialog-footer">
            <el-button @click="cancel">取 消</el-button>
            <el-button type="primary" @click="handleSubmit" :loading="submitting">确 定</el-button>
        </div>
    </div>
</template>
  
<script>
import Vue from "vue";
export default {
    name: 'l-user-additional-rebind',
    props: {
        id: {
            type: [String, Number],
            default: null
        },
        visible: {
            type: Boolean,
        },
        cz_state: {
            type: [String, Number],
            default: null
        },
    },

    components: {
    },
    computed: {
        hasId() {
            return this.$props.id !== null;
        },
    },
    // watch: {

    // },
    data() {
        return {
            upload_url: Vue.$_config.upload_url,
            fileList: [],
            // 修改 的图片
            photo_preview: "",
            photo_2_preview: "",
            loading: false,//页面是否加载中
            app_list:
            {
                1: "星伴"
            }
            ,

            //是否显示
            value1: '',
            //表单数据
            form_data: {
                admin_id: "",
                remark: ""
                // add_time: "",
                // photo: []
            },
            //表单验证规则
            rules: {
                admin_id: [
                    { required: true, message: '员工ID不能为空', trigger: 'change' }
                ],

            },
            //提交按钮是否显示加载中
            submitting: false,
        }
    },
    methods: {
        //上传图标成功后的回调
        handleUploadSuccess(res, field) {
            console.log(res.data.photo);
            this.form_data.photo.push(res.data.photo);
            this[field + "_preview"] = res.data.photo;
        },
        //点击取消通知父组件关闭对话框
        cancel() {
            this.$emit('update:visible', false);
        },

        //提交数据
        handleSubmit() {
            // console.log(this.form_data);
            if (this.loading) return;
            this.$refs.form.validate((valid) => {
                if (valid) {
                    this.submitting = true;
                    this.$_invoke('adminUserAdditional_rebind', {
                        id: this.$props.id,
                        remark: this.form_data.remark,
                        admin_id: this.form_data.admin_id
                    }).then(() => {
                        this.$_msg.success('改绑成功');
                        this.$emit('on-success');
                    }).finally(() => {
                        this.submitting = false;
                    })
                }
            }
            )

        },
    },
}
</script>